import styled from 'styled-components';
export const InputWrapper = styled.div`
  height: 45px;
  margin: 0.9375em 0px;
`;
